import { IBatchAddStScheduledExercisePayload } from '@/types'
import { httpClient } from './httpClient'

export interface EditStScheduledExerciseAPIRequestPayload {
  stScheduledExercisesData: {
    id: number
    dayNumber?: number
    sequenceOrder?: number
  }[]
}

export async function deleteBatchStScheduledExercise ({
  stScheduledExerciseId
}: {
  stScheduledExerciseId: number[]
}) {
  try {
    const url = import.meta.env.VITE_BATCH_DELETE_SCHEDULED_TPL_EXERCISE_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'DELETE',
      withCredentials: true,
      data: {
        scheduledExerciseIds: stScheduledExerciseId
      }
    })

    return response?.data
  } catch (error) {
    console.error('deleteStScheduledExercise - Error: ', error)
    throw error
  }
}

export async function addBatchStScheduledExercise ({
  addStScheduledExerciseRequestPayload
}: {
  addStScheduledExerciseRequestPayload: IBatchAddStScheduledExercisePayload
}) {
  const { tplScheduleId, exercises } = addStScheduledExerciseRequestPayload

  try {
    let url = import.meta.env.VITE_BATCH_ADD_SCHEDULED_TPL_EXERCISE_ENDPOINT
    url = url.replace('__scheduleId__', tplScheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'POST',
      data: { exercises },
      withCredentials: true
    })

    return response?.data
  } catch (error) {
    console.error('addBatchStScheduledExercise - Error: ', error)
    throw error
  }
}

export async function editBatchStScheduledExercise (
  editStScheduledExerciseRequestPayload: EditStScheduledExerciseAPIRequestPayload
) {
  const { stScheduledExercisesData } = editStScheduledExerciseRequestPayload

  try {
    const url = import.meta.env.VITE_BATCH_EDIT_SCHEDULED_TPL_EXERCISE_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'PUT',
      data: { exercises: stScheduledExercisesData }
    })

    return response?.data
  } catch (error) {
    console.error('editStScheduledExercise - Error: ', error)
    throw error
  }
}
